export const environment = {
  production: true,
  logsAppKey: '',
  appVersion: '1.0.0-prd',
  logsEnabled: true,
  useGatewayAuth: true,
  host: 'https://www.clientespolpaico.cl/',
  ResourceServer: 'https://polpaicotest.rankeadictos.cl/api/',
  ApiVersion: 'v1',
  ResourceLogin: 'https://www.polpaicoconexion.cl/clientes/ws/login_v2.aspx',
  ResourcePassWordRecovery: 'https://www.polpaicoconexion.cl/clientes/ws/recupera_clave.aspx',
  ResourceSaldoProductos: 'https://www.polpaicoconexion.cl/clientes/ws/contratos.aspx',
  ResourcePolpaico: 'https://www.polpaicoconexion.cl/clientes/ws/',
  ResourceDespachoSeguimiento: 'https://www.polpaicoconexion.cl/clientes/map.aspx?code=',
  ApiEcomer: 'https://back-ecommerce-dev.azurewebsites.net/api/v2/EcommerceOrder',
  ApiRunPdf: 'https://www.polpaicoconexion.cl/guias_cemento/guiaspd_setfirma.aspx',
  ApiNotificaciones: 'https://www.polpaicoconexion.cl/clientes/ws/mx_notif_v2.aspx',
  ApiERO: 'https://2o2xepa93c.execute-api.us-east-1.amazonaws.com',
  daysEncuestaMixer: 7,
  moduloERO: 'checklist',
  seguimientoAnonimoPublicPath: '/Seguimiento/3',
  seguimientoAnonimoEnabled: true,
};
